import BaseService from "../core/base-service";
import StorageService from "../core/storage-service";

export default class TechService extends BaseService {
  // TODO: change this to your route in server
  static route = "tech";
  private storage: StorageService = new StorageService();

  /*专利列表接口*/
  async getTechData(pageNo = 1, title?: string, area?: string) {
    const url = `/api/patent/techs`;
    const formData = {
      page: pageNo,
      size: 10,
    };

    title ? ((formData as any)["title"] = title) : void 0;
    area ? ((formData as any)["area"] = area) : void 0;

    const response = await this.httpService.post<any, any>(url, formData);
    return response;
  }

  async getTechDetailData(id: string) {
    const url = `/api/patent/techs/${id}`;
    const response = await this.httpService.get<any>(url);
    return response;
  }

  /*报名接口*/
  async postRegistrationForm(formData: any): Promise<any> {
    const response = await this.httpService.post<any, any>(
      `/api/c/patent/hlj/create`,
      formData
    );
    return response;
  }

  async login(email: string, password: string): Promise<any> {
    const response = await this.httpService.post<any, any>(
      `${this.path}/login`,
      { username: email, password }
    );
    // console.log('response', response)
    return response.data;
  }

  async upload(file: File): Promise<any> {
    const encodeParam = encodeURI(
      Date.now() + (Math.random() * 100).toFixed(0) + "_" + file.name
    );
    const url = `/misc/upload?bucketName=techdeal&pathName=%2fpatent%2f${encodeParam}`;
    let formdata = new FormData();
    formdata.set("file", file);
    const response = await this.httpService.upload<any, any>(url, formdata);
    console.log("上传结果", response);
    return response;
  }

  async register(email: string, password: string): Promise<any> {
    const response = await this.httpService.post<any, any>(
      `${this.path}/register`,
      { username: email, password }
    );

    return response.data;
  }

  /** 获取评分列表 */
  async scoreList(type: string, orgField: string, status: string): Promise<any> {
	const url = '/api/c/patent/works/judgings';
    // const url = process.env.NODE_ENV === 'development' ? '/api/patent/works/judgings/test' : '/api/c/patent/works/judgings';
    const userId = process.env.NODE_ENV === 'development' ? 8 : null;
    const response = await this.httpService.post<any, any>(
        `${ url}`,
        { type, orgField, status, userId,year: "2024" }
    );

    return response;
  }
  /** 获取打分详情*/
  async getScoreDetail(id: string ): Promise<any> {
	const url = `/api/c/patent/worksjudgings/score/${id}`;
    // const url = process.env.NODE_ENV === 'development' ? `/api/patent/worksjudgings/score/test/${id}?userId=32` : `/api/c/patent/worksjudgings/score/${id}`;
    const response = await this.httpService.get<any>(
        `${url}`,
    );

    return response;
  }

  /** 报名接口 */
  async postScore(formData: any): Promise<any> {
	const url = `/api/c/patent/works/judgings/score`;
    // const url = process.env.NODE_ENV === 'development' ? `/api/patent/works/judgings/score/test` : `/api/c/patent/works/judgings/score`;
    // if (process.env.NODE_ENV === 'development') {
    //   formData.userId = 32;
    // }
    const response = await this.httpService.post<any, any>(
        url,
        formData
    );
    return response;
  }

  /** 报名接口 */
  async checkAvailble(): Promise<any> {
    const url =  `/api/patent/works/available`;
    const response = await this.httpService.get<any>(
        `${url}?year=2025`
    );
    return response;
  }
}
